import styled from "styled-components";
import {LobbyHeaderTitleDefaultBox} from "./lobby-header-title.default.box";

export const LobbyHeaderTitleCasino777Box = styled(LobbyHeaderTitleDefaultBox)`
    font-size: 2.2rem;
    color: ${({theme}) => theme.colors.moneyColor};
    ${({theme}) => theme.font.presets.bold};
`;
